import { render, staticRenderFns } from "./kinesisStream.vue?vue&type=template&id=516ba08c&"
import script from "./kinesisStream.vue?vue&type=script&lang=js&"
export * from "./kinesisStream.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports